const values = [
  "icon_enhance_ mummybarracks_hallowedtithe",
  "icon_enhance_ mummybarracks_lector",
  "icon_enhance_ mummybarracks_sandsurge",
  "icon_enhance_arrowtower_extraarcher",
  "icon_enhance_arrowtower_huntersmark",
  "icon_enhance_arrowtower_multishot",
  "icon_enhance_arrowtower_rapidshot",
  "icon_enhance_axemantower_axearang",
  "icon_enhance_axemantower_enduringrage",
  "icon_enhance_axemantower_targetpractice",
  "icon_enhance_barracks_dualwield",
  "icon_enhance_barracks_secondwind",
  "icon_enhance_barracks_sunder",
  "icon_enhance_beetletower_albitarsishybrid",
  "icon_enhance_beetletower_carrionfeeder",
  "icon_enhance_beetletower_rupture",
  "icon_enhance_bigheadtower_dancingfire",
  "icon_enhance_bigheadtower_livingflame",
  "icon_enhance_bigheadtower_searingpain",
  "icon_enhance_cannontower_bfrocekt",
  "icon_enhance_cannontower_concussiveblast",
  "icon_enhance_cannontower_shrapnel",
  "icon_enhance_cannontower_spikebomb",
  "icon_enhance_catapulttower_heavyimpact",
  "icon_enhance_catapulttower_rocksalvo",
  "icon_enhance_catapulttower_spottercrew",
  "icon_enhance_centaurarcher_warhall",
  "icon_enhance_centaurbarracks_rallyinghorn",
  "icon_enhance_centaurbarracks_serratedblades",
  "icon_enhance_centaurbarracks_severtendons",
  "icon_enhance_cloudtower_ blownaway",
  "icon_enhance_cloudtower_billowingram",
  "icon_enhance_cloudtower_winterwarning",
  "icon_enhance_crusader_blessed_hammer",
  "icon_enhance_crusader_punish",
  "icon_enhance_crusader_zeal",
  "icon_enhance_darkportal_conscriptdead",
  "icon_enhance_darkportal_corruptedblades",
  "icon_enhance_darkportal_darkconflagration",
  "icon_enhance_darkspire_curse",
  "icon_enhance_darkspire_deathbeam",
  "icon_enhance_darkspire_torment",
  "icon_enhance_dragoonbarracks_crush",
  "icon_enhance_dragoonbarracks_leap",
  "icon_enhance_dragoonbarracks_resound",
  "icon_enhance_druidtower_lightning_lure",
  "icon_enhance_druidtower_stormcaller",
  "icon_enhance_druidtower_wilds_shape",
  "icon_enhance_flamecannon_furnace",
  "icon_enhance_flamecannon_furyaura",
  "icon_enhance_flamecannon_heatseekers",
  "icon_enhance_frosttower_absolutezero",
  "icon_enhance_frosttower_shatter",
  "icon_enhance_frosttower_tempestaura",
  "icon_enhance_huntershut_trapmaster",
  "icon_enhance_huntershut_watchful_eye",
  "icon_enhance_huntershut_woof_zooka",
  "icon_enhance_iceman_ice_spikes",
  "icon_enhance_iceman_throw",
  "icon_enhance_iceman_yodel_taunt",
  "icon_enhance_lavaooze_subdivide",
  "icon_enhance_lavaooze_volatile",
  "icon_enhance_lavaooze_volcanicactivity",
  "icon_enhance_leviathan_ink_spray",
  "icon_enhance_leviathan_undertow",
  "icon_enhance_leviathan_water_spout",
  "icon_enhance_lighthouse_bindinglight",
  "icon_enhance_lighthouse_guardian",
  "icon_enhance_lighthouse_healingword",
  "icon_enhance_mermagetower_Pufferfish",
  "icon_enhance_mermagetower_squall",
  "icon_enhance_mermagetower_tidalwave",
  "icon_enhance_oiltower_burnoff",
  "icon_enhance_oiltower_exhaustfan",
  "icon_enhance_oiltower_petrocannon",
  "icon_enhance_planttower_deathblossom",
  "icon_enhance_planttower_drowsinesspollen",
  "icon_enhance_planttower_soothingvapor",
  "icon_enhance_potiondealer_corrosion",
  "icon_enhance_potiondealer_healing_potion",
  "icon_enhance_potiondealer_unidentified_potion",
  "icon_enhance_repeater_bolashot",
  "icon_enhance_repeater_deadeye",
  "icon_enhance_repeater_explosivebolt",
  "icon_enhance_scorcher_face_melt",
  "icon_enhance_scorcher_living_bomb",
  "icon_enhance_scorcher_meteor_strike",
  "icon_enhance_stoneguard_bash",
  "icon_enhance_stoneguard_hamertoss",
  "icon_enhance_stoneguard_stoneskin",
  "icon_enhance_sunsanctum_solar_beam",
  "icon_enhance_sunsanctum_solar_flare",
  "icon_enhance_sunsanctum_sunlight",
  "icon_enhance_teslatower_capacitor",
  "icon_enhance_teslatower_chainlightning",
  "icon_enhance_teslatower_lightningrod",
  "icon_enhance_warlocktower_darkacolyte",
  "icon_enhance_warlocktower_shadowfire",
  "icon_enhance_warlocktower_undyinghunger",
  "icon_ingame_hero_alchemist_musketter",
  "icon_ingame_hero_angelwings",
  "icon_ingame_hero_angelwings_awaken",
  "icon_ingame_hero_angelwings_infernal",
  "icon_ingame_hero_angelwings_teotl",
  "icon_ingame_hero_angel_wings",
  "icon_ingame_hero_avalanchesurfer_cloudrider",
  "icon_ingame_hero_avalanchesurfer_poolparty",
  "icon_ingame_hero_avalanchesurfer_star",
  "icon_ingame_hero_avalanche_surfer",
  "icon_ingame_hero_bearchief",
  "icon_ingame_hero_bearchief_awaken",
  "icon_ingame_hero_bearchief_naval",
  "icon_ingame_hero_beemistress",
  "icon_ingame_hero_beemistress_awaken",
  "icon_ingame_hero_beemistress_thief",
  "icon_ingame_hero_beetlewarrior",
  "icon_ingame_hero_beetlewarrior_awaken",
  "icon_ingame_hero_beetlewarrior_pool",
  "icon_ingame_hero_centaurarcher",
  "icon_ingame_hero_centaurarcher_awaken",
  "icon_ingame_hero_centaurarcher_dryad",
  "icon_ingame_hero_chosengirl_grandmaster",
  "icon_ingame_hero_chosengirl_priestess",
  "icon_ingame_hero_chosen_girl",
  "icon_ingame_hero_cloudrabbit",
  "icon_ingame_hero_cloudrabbit_awaken",
  "icon_ingame_hero_cloudrabbit_tiger",
  "icon_ingame_hero_cloudviking",
  "icon_ingame_hero_cloudviking_awaken",
  "icon_ingame_hero_cloudviking_dieselpunk",
  "icon_ingame_hero_crazy_alchemsit",
  "icon_ingame_hero_deathknight_awaken",
  "icon_ingame_hero_deathknight_star",
  "icon_ingame_hero_death_knight",
  "icon_ingame_hero_dragoon_gm6",
  "icon_ingame_hero_dragoon_star",
  "icon_ingame_hero_dryad",
  "icon_ingame_hero_dryad_awaken",
  "icon_ingame_hero_dryad_chef",
  "icon_ingame_hero_dryad_tropical",
  "icon_ingame_hero_evilwings_poolparty",
  "icon_ingame_hero_evilwing_swampwitch",
  "icon_ingame_hero_evil_wings",
  "icon_ingame_hero_flamegoddess",
  "icon_ingame_hero_flamegoddess_awaken",
  "icon_ingame_hero_flamegoddess_catgirl",
  "icon_ingame_hero_flamethrower_awaken",
  "icon_ingame_hero_flamethrower_firewoman",
  "icon_ingame_hero_flamethrower_landscaper",
  "icon_ingame_hero_flame_thrower",
  "icon_ingame_hero_foreseer",
  "icon_ingame_hero_foreseer_awaken",
  "icon_ingame_hero_foreseer_citizen",
  "icon_ingame_hero_hercules",
  "icon_ingame_hero_hercules_awaken",
  "icon_ingame_hero_hercules_mafia",
  "icon_ingame_hero_iceMage_dapper",
  "icon_ingame_hero_last_dragoon",
  "icon_ingame_hero_last_dragoon_musketeer",
  "icon_ingame_hero_lavachef_awaken",
  "icon_ingame_hero_lavachef_eaglewarrior",
  "icon_ingame_hero_lavachef_skinwitch",
  "icon_ingame_hero_lava_chef",
  "icon_ingame_hero_lionking",
  "icon_ingame_hero_lionking_awaken",
  "icon_ingame_hero_lionking_bbqchef",
  "icon_ingame_hero_lionking_boxer",
  "icon_ingame_hero_mefolk_maskedheroine",
  "icon_ingame_hero_merfolk_dapper",
  "icon_ingame_hero_merfolk_fighter",
  "icon_ingame_hero_merfolk_poolparty",
  "icon_ingame_hero_ramhammer_grandvizier",
  "icon_ingame_hero_ramhammer_piratelord",
  "icon_ingame_hero_ram_hammer",
  "icon_ingame_hero_reaper",
  "icon_ingame_hero_reaper_awaken",
  "icon_ingame_hero_reaper_infernal",
  "icon_ingame_hero_reaper_spades",
  "icon_ingame_hero_ronin",
  "icon_ingame_hero_ronin_awaken",
  "icon_ingame_hero_ronin_miku",
  "icon_ingame_hero_ronin_surgeriver",
  "icon_ingame_hero_sandscorpion",
  "icon_ingame_hero_sandscorpion_awaken",
  "icon_ingame_hero_sandscorpion_tribal",
  "icon_ingame_hero_smith_gm6",
  "icon_ingame_hero_smith_grandmaster",
  "icon_ingame_hero_smith_infernal",
  "icon_ingame_hero_toadshaman_awaken",
  "icon_ingame_hero_toadshaman_pirate",
  "icon_ingame_hero_toad_shaman",
  "icon_ingame_hero_tower_smith",
  "icon_ingame_hero_traveling_mage",
  "icon_ingame_hero_windknight_gm6",
  "icon_ingame_hero_windknight_grandmaster",
  "icon_ingame_hero_windknight_musketeer",
  "icon_ingame_hero_windknight_star",
  "icon_ingame_hero_wind_knight",
  "icon_ingame_hero_wolfhuntress",
  "icon_ingame_hero_wolfhuntress_awaken",
  "icon_ingame_hero_wolfhuntress_woodlands",
  "icon_ingame_hero_yeti",
  "icon_ingame_hero_yeti_dapper",
  "icon_ingame_hero_yeti_shortstop",
  "icon_ingame_herp_wolfhuntress_maskedheroine",
  "icon_ingame_lighthouse_unit_rank03",
  "btn_unit_wildsky_turkey",
  "icon_ingame_ramhammer_altar_blessing",
  "icon_ingame_spell_shield",
  "icon_misc_portal_blue",
  "icon_misc_portal_red",
  "icon_misc_running_boot",
  "icon_spell_angelic_host",
  "icon_spell_barrel_rocket",
  "icon_spell_bolster",
  "icon_spell_breathoffire",
  "icon_spell_bubbleblast",
  "icon_spell_castthebones",
  "icon_spell_consecrate",
  "icon_spell_darksummons",
  "icon_spell_dark_transmutation",
  "icon_spell_desecrate",
  "icon_spell_divinecommand",
  "icon_spell_dragon_firebreath",
  "icon_spell_dynastinae",
  "icon_spell_fireball",
  "icon_spell_fire_trap",
  "icon_spell_focus_fire",
  "icon_spell_freeze_and_mana",
  "icon_spell_frost_trap",
  "icon_spell_fungalbloom",
  "icon_spell_giftofkinahau",
  "icon_spell_golden_cannon",
  "icon_spell_greed_cannon",
  "icon_spell_harpoon",
  "icon_spell_healing_and_charge",
  "icon_spell_holy_avengers",
  "icon_spell_holy_nova",
  "icon_spell_howling_blast",
  "icon_spell_ice_rupture",
  "icon_spell_ice_spike",
  "icon_spell_judgement",
  "icon_spell_lightning_bolt",
  "icon_spell_magmafall",
  "icon_spell_manablast",
  "icon_spell_manastorm",
  "icon_spell_mask",
  "icon_spell_mightofyaoga",
  "icon_spell_mines_overcharge",
  "icon_spell_polybomb",
  "icon_spell_rally_cry",
  "icon_spell_salvo",
  "icon_spell_skywindsaga",
  "icon_spell_spikedbarricade",
  "icon_spell_summon_dragon",
  "icon_spell_summon_harbinger",
  "icon_spell_talent_barrier",
  "icon_spell_talent_hullarmor",
  "icon_spell_talent_laststand",
  "icon_spell_talent_rexrepairs",
  "icon_spell_talent_sorcererstone",
  "icon_spell_talent_spellsurge",
  "icon_spell_talent_warbond",
  "icon_spell_thunder_wave",
  "icon_spell_tower_boost",
  "icon_spell_treants",
  "icon_spell_trickortreat",
  "icon_spell_typhoon",
  "icon_spell_vine_lash",
  "icon_spell_warbots",
  "icon_ingame_cooldown",
  "icon_ingame_towerslot_arrowtower",
  "icon_ingame_towerslot_axemantower",
  "icon_ingame_towerslot_barracks",
  "icon_ingame_towerslot_beetletower",
  "icon_ingame_towerslot_bigheadtower",
  "icon_ingame_towerslot_cannontower",
  "icon_ingame_towerslot_catapulttower",
  "icon_ingame_towerslot_centaurbarracks",
  "icon_ingame_towerslot_cloudtower",
  "icon_ingame_towerslot_crusader",
  "icon_ingame_towerslot_darkportal",
  "icon_ingame_towerslot_darkspire",
  "icon_ingame_towerslot_dragoonbarracks",
  "icon_ingame_towerslot_druidtower",
  "icon_ingame_towerslot_flamecannon",
  "icon_ingame_towerslot_frosttower",
  "icon_ingame_towerslot_huntershut",
  "icon_ingame_towerslot_icemantower",
  "icon_ingame_towerslot_lavaooze",
  "icon_ingame_towerslot_leviathan",
  "icon_ingame_towerslot_lighthouse",
  "icon_ingame_towerslot_merman",
  "icon_ingame_towerslot_mummybarracks",
  "icon_ingame_towerslot_oiltower",
  "icon_ingame_towerslot_planttower",
  "icon_ingame_towerslot_potiondealer",
  "icon_ingame_towerslot_repeater",
  "icon_ingame_towerslot_scorcher",
  "icon_ingame_towerslot_stoneguard",
  "icon_ingame_towerslot_sunsanctum",
  "icon_ingame_towerslot_teslatower",
  "icon_ingame_towerslot_warlocktower",
  "icon_enhancement_bar_one_blue_lv0",
  "icon_enhancement_bar_one_blue_lv1",
  "icon_enhancement_bar_one_brown_lv0",
  "icon_enhancement_bar_one_brown_lv1",
  "icon_enhancement_bar_one_gold_lv0",
  "icon_enhancement_bar_one_gold_lv1",
  "icon_enhancement_bar_one_green_lv0",
  "icon_enhancement_bar_one_green_lv1",
  "icon_enhancement_bar_one_purple_lv0",
  "icon_enhancement_bar_one_purple_lv1",
  "icon_enhancement_bar_one_red_lv0",
  "icon_enhancement_bar_one_red_lv1",
  "icon_enhancement_bar_three_blue_lv0",
  "icon_enhancement_bar_three_blue_lv1",
  "icon_enhancement_bar_three_blue_lv2",
  "icon_enhancement_bar_three_blue_lv3",
  "icon_enhancement_bar_three_brown_lv0",
  "icon_enhancement_bar_three_brown_lv1",
  "icon_enhancement_bar_three_brown_lv2",
  "icon_enhancement_bar_three_brown_lv3",
  "icon_enhancement_bar_three_gold_lv0",
  "icon_enhancement_bar_three_gold_lv1",
  "icon_enhancement_bar_three_gold_lv2",
  "icon_enhancement_bar_three_gold_lv3",
  "icon_enhancement_bar_three_green_lv0",
  "icon_enhancement_bar_three_green_lv1",
  "icon_enhancement_bar_three_green_lv2",
  "icon_enhancement_bar_three_green_lv3",
  "icon_enhancement_bar_three_purple_lv0",
  "icon_enhancement_bar_three_purple_lv1",
  "icon_enhancement_bar_three_purple_lv2",
  "icon_enhancement_bar_three_purple_lv3",
  "icon_enhancement_bar_three_red_lv0",
  "icon_enhancement_bar_three_red_lv1",
  "icon_enhancement_bar_three_red_lv2",
  "icon_enhancement_bar_three_red_lv3",
  "icon_enhancement_bar_two_blue_lv0",
  "icon_enhancement_bar_two_blue_lv1",
  "icon_enhancement_bar_two_blue_lv2",
  "icon_enhancement_bar_two_brown_lv0",
  "icon_enhancement_bar_two_brown_lv1",
  "icon_enhancement_bar_two_brown_lv2",
  "icon_enhancement_bar_two_gold_lv0",
  "icon_enhancement_bar_two_gold_lv1",
  "icon_enhancement_bar_two_gold_lv2",
  "icon_enhancement_bar_two_green_lv0",
  "icon_enhancement_bar_two_green_lv1",
  "icon_enhancement_bar_two_green_lv2",
  "icon_enhancement_bar_two_purple_lv0",
  "icon_enhancement_bar_two_purple_lv1",
  "icon_enhancement_bar_two_purple_lv2",
  "icon_enhancement_bar_two_red_lv0",
  "icon_enhancement_bar_two_red_lv1",
  "icon_enhancement_bar_two_red_lv2",
  "icon_enhancement_bar_blue_lv0",
  "icon_enhancement_bar_blue_lv1",
  "icon_enhancement_bar_blue_lv2",
  "icon_enhancement_bar_blue_lv3",
  "icon_enhancement_bar_brown_lv0",
  "icon_enhancement_bar_brown_lv1",
  "icon_enhancement_bar_brown_lv2",
  "icon_enhancement_bar_brown_lv3",
  "icon_enhancement_bar_double_blue_lv0",
  "icon_enhancement_bar_double_blue_lv1",
  "icon_enhancement_bar_double_blue_lv2",
  "icon_enhancement_bar_double_brown_lv0",
  "icon_enhancement_bar_double_brown_lv1",
  "icon_enhancement_bar_double_brown_lv2",
  "icon_enhancement_bar_double_gold_lv0",
  "icon_enhancement_bar_double_gold_lv1",
  "icon_enhancement_bar_double_gold_lv2",
  "icon_enhancement_bar_double_green_lv0",
  "icon_enhancement_bar_double_green_lv1",
  "icon_enhancement_bar_double_green_lv2",
  "icon_enhancement_bar_double_purple_lv0",
  "icon_enhancement_bar_double_purple_lv1",
  "icon_enhancement_bar_double_purple_lv2",
  "icon_enhancement_bar_double_red_lv0",
  "icon_enhancement_bar_double_red_lv1",
  "icon_enhancement_bar_double_red_lv2",
  "icon_enhancement_bar_gold_lv0",
  "icon_enhancement_bar_gold_lv1",
  "icon_enhancement_bar_gold_lv2",
  "icon_enhancement_bar_gold_lv3",
  "icon_enhancement_bar_green_lv0",
  "icon_enhancement_bar_green_lv1",
  "icon_enhancement_bar_green_lv2",
  "icon_enhancement_bar_green_lv3",
  "icon_enhancement_bar_purple_lv0",
  "icon_enhancement_bar_purple_lv1",
  "icon_enhancement_bar_purple_lv2",
  "icon_enhancement_bar_purple_lv3",
  "icon_enhancement_bar_red_lv0",
  "icon_enhancement_bar_red_lv1",
  "icon_enhancement_bar_red_lv2",
  "icon_enhancement_bar_red_lv3",
  "icon_enhancement_bar_single_blue_lv0",
  "icon_enhancement_bar_single_blue_lv1",
  "icon_enhancement_bar_single_brown_lv0",
  "icon_enhancement_bar_single_brown_lv1",
  "icon_enhancement_bar_single_gold_lv0",
  "icon_enhancement_bar_single_gold_lv1",
  "icon_enhancement_bar_single_green_lv0",
  "icon_enhancement_bar_single_green_lv1",
  "icon_enhancement_bar_single_purple_lv0",
  "icon_enhancement_bar_single_purple_lv1",
  "icon_enhancement_bar_single_red_lv0",
  "icon_enhancement_bar_single_red_lv1",
  "icon_ingame_towerslot_info",
  "icon_ingame_towerslot_info_board",
  "icon_ingame_towerslot_rallypoint",
  "icon_ingame_towerslot_sell",
  "icon_ingame_towerslot_sell_confirm",
  "icon_ingame_towerslot_upgrade",
  "icon_ingame_towerslot_upgrade_blue",
  "icon_ingame_towerslot_upgrade_brown",
  "icon_ingame_towerslot_upgrade_gold",
  "icon_ingame_towerslot_upgrade_green",
  "icon_ingame_towerslot_upgrade_purple",
  "icon_ingame_towerslot_upgrade_red",
  "icon_towerslot_affinity_blue",
  "icon_towerslot_affinity_brown",
  "icon_towerslot_affinity_gold",
  "icon_towerslot_affinity_green",
  "icon_towerslot_affinity_purple",
  "icon_towerslot_affinity_red",
  "icon_towerslot_ornament_brown",
  "icon_towerslot_ornament_green",
  "icon_towerslot_ornament_red",
  "icon_towerslot_price_blue",
  "icon_towerslot_price_brown",
  "icon_towerslot_price_gold",
  "icon_towerslot_price_green",
  "icon_towerslot_price_purple",
  "icon_towerslot_price_red",
  "icon_tower_slot00",
  "bar_energy00_empty",
  "bar_energy00_fill",
  "bar_mana01_cost",
  "bar_mana01_empty",
  "bar_mana01_fill",
  "bar_mana_slot",
  "bar_portrait_energy_empty",
  "bar_portrait_energy_fill",
  "bar_portrait_health_empty",
  "bar_portrait_health_fill",
  "btn_speed",
  "btn_wave_bg",
  "btn_wave_flying",
  "btn_wave_image",
  "btn_wave_pointer",
  "btn_wave_progress",
  "dialog_bubble",
  "dialog_exclamation",
  "dialog_frame_01",
  "dialog_frame_02",
  "dialog_frame_03",
  "grid_01",
  "grid_02",
  "grid_03",
  "grid_04",
  "grid_05",
  "grid_06",
  "health_bar_boss_empty",
  "health_bar_boss_fill",
  "health_bar_boss_special",
  "health_bar_boss_special_fill",
  "health_bar_boss_special_white",
  "health_bar_enemy_empty00",
  "health_bar_enemy_fill00",
  "health_bar_enemy_fill00_shield",
  "health_bar_player_empty00",
  "health_bar_player_empty01",
  "health_bar_player_fill00",
  "health_bar_player_fill00_shield",
  "health_bar_player_fill01",
  "health_bar_player_fill01_shield",
  "health_bar_troop_empty00",
  "health_bar_troop_fill00",
  "health_bar_troop_fill00_shield",
  "hero_skill",
  "hero_skill_target",
  "icon_event_merfolk_goldenegg",
  "pause",
  "pointy_finger",
  "select",
  "select2",
  "setting",
  "ui_cross",
  "ui_ingame_coin",
  "ui_ingame_enemywave",
  "ui_ingame_gift",
  "ui_ingame_hub",
  "ui_ingame_island",
  "ui_ingame_mana",
  "ui_ingame_towerslot_ring",
  "ui_music",
  "ui_sound",
  "ui_upgrade_pip",
];
export default values;
